export default __webpack_public_path__ + "media/images/icons/trash-alt-regular-96ae42b30b69a72a189ad46b74580804.svg";